export default __webpack_public_path__ + "b285118.png";